"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLocationReactor = exports.DEBOUNCE_INTERVAL = void 0;
var tslib_1 = require("tslib");
var bernie_core_1 = require("bernie-core");
var React = require("react");
var bernie_client_events_1 = require("../../../events/bernie-client-events");
var logger_1 = require("../../../logger");
var logger = logger_1.ClientLogger.getLoggerWithIdentifier('bernie.client.location-reactor');
exports.DEBOUNCE_INTERVAL = 150;
function withLocationReactor(WrappedComponent, callback, deactivate) {
  var LocationReactor = /** @class */function (_super) {
    tslib_1.__extends(LocationReactorWrapper, _super);
    function LocationReactorWrapper(props) {
      var _this = _super.call(this, props) || this;
      _this.componentIsMounted = false;
      _this.state = {
        location: props.location
      };
      return _this;
    }
    LocationReactorWrapper.prototype.componentWillUnmount = function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.componentIsMounted = false;
      if (deactivate) {
        deactivate(this.state.location);
      }
    };
    LocationReactorWrapper.prototype.componentDidMount = function () {
      this.componentIsMounted = true;
      if (this.props.location) {
        this.updateLocation(undefined, this.props.location);
      }
    };
    LocationReactorWrapper.prototype.shouldComponentUpdate = function (nextProps, nextState) {
      if (this.props.location.pathname !== nextProps.location.pathname || this.props.location.hash !== nextProps.location.hash || this.props.location.key !== nextProps.location.key || !LocationReactorWrapper.isQueryEqual(this.props.location.query, nextProps.location.query)) {
        this.updateLocation(this.props.location, nextProps.location);
      }
      return nextState.location !== this.state.location;
    };
    LocationReactorWrapper.isQueryEqual = function (query1, query2) {
      var e_1, _a;
      var query1Keys = Object.keys(query1 || {});
      var query2Keys = Object.keys(query2 || {});
      if (query1Keys.length !== query2Keys.length) {
        return false;
      }
      try {
        for (var query1Keys_1 = tslib_1.__values(query1Keys), query1Keys_1_1 = query1Keys_1.next(); !query1Keys_1_1.done; query1Keys_1_1 = query1Keys_1.next()) {
          var key = query1Keys_1_1.value;
          if (!query2Keys.includes(key) || query2[key] !== query1[key]) {
            return false;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (query1Keys_1_1 && !query1Keys_1_1.done && (_a = query1Keys_1.return)) _a.call(query1Keys_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return true;
    };
    LocationReactorWrapper.prototype.updateLocation = function (prevLocation, location) {
      return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }
          return [2 /*return*/, new Promise(function (resolve, reject) {
            _this.timeout = (window || global).setTimeout(function () {
              callback({
                prev: prevLocation,
                next: location
              }).catch(function (error) {
                logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.LOCATION_REACTOR_CALLBACK_ERROR, error);
                return {
                  query: null
                };
              }).then(function (result) {
                var _a;
                var history = _this.props.history;
                if (history && location && result && result.query && (((_a = result.query) === null || _a === void 0 ? void 0 : _a.length) || Object.keys(result.query).length > 0)) {
                  (0, bernie_core_1.updateSearch)({
                    history: history,
                    location: location,
                    newParams: result.query,
                    replace: result.replace
                  });
                  resolve(true);
                } else if (_this.componentIsMounted) {
                  _this.setState({
                    location: location
                  }, function () {
                    resolve(true);
                  });
                } else {
                  resolve(false);
                }
              }).catch(reject);
            }, exports.DEBOUNCE_INTERVAL);
          })];
        });
      });
    };
    LocationReactorWrapper.prototype.render = function () {
      var _a = this.props,
        location = _a.location,
        props = tslib_1.__rest(_a, ["location"]);
      return React.createElement(WrappedComponent, tslib_1.__assign({
        location: this.state.location
      }, props));
    };
    return LocationReactorWrapper;
  }(React.Component);
  LocationReactor.wrappedComponent = LocationReactor;
  return LocationReactor;
}
exports.withLocationReactor = withLocationReactor;